import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import HtmlInNewWindow from '../utils/HtmlInNewWindow'; // Import the new component
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import UserNameContext from '../UserNameContext';
import EnvContext from "../envContext";
import configData from '../sso_config.json';
import { useMsal } from "@azure/msal-react";
import { functionAppLoginRequest } from "../msalConfig";

function GetDeviceDetails() {
      console.log('Inside GetDeviceDetails component');
      const [selectedOption, setSelectedOption] = useState('');
      const [textBox1, setTextBox1] = useState('');
      const [responseData, setResponseData] = useState(null); // State to store the response data
      const [responseHtml, setResponseHtml] = useState(null); // State to store the response HTML
      const [loading, setLoading] = useState(false); // State to track loading status
      const [isSubmitted, setIsSubmitted] = useState(false); // State to track if the form was submitted
      const navigate = useNavigate();
      
      const { instance, accounts } = useMsal();
      // Pass username to Azure function using Json object
      const myObj = {
        userName: useContext(UserNameContext), 
      }
      const userName = JSON.stringify(myObj);
      console.log("userName",userName);

      const env = useContext(EnvContext);
      console.log("ENV", env);
      const [textBox2, setTextBox2] = useState(env);

      let endpointUrl;
      // API endpoint URL
      if(process.env.REACT_APP_RUN_ENV === 'local') {
          endpointUrl = configData.LOCAL_API_URL + "get_device_details"; // Use the local API URL from the config file
         // endpointUrl = 'http://localhost:7071/api/get_device_details';   
      } else if (process.env.REACT_APP_RUN_ENV === 'qe') {
          endpointUrl = configData.QE_API_URL + "get_device_details"; // Use the QE API URL from the config file
          //endpointUrl = 'https://xiosupporttool.azurewebsites.net/api/get_device_details';
      } else {
         //endpointUrl = 'https://prd-use-atsgtool-func.azurewebsites.net/api/get_device_details';
          endpointUrl = configData.PROD_API_URL + "get_device_details"; // Use the production API URL from the config file
      }

      console.log("endpoint url is",endpointUrl);
      const handleSubmit = async (e) => {
            e.preventDefault();

            // Create alert in browser if required fields are missing
            if (!selectedOption || !textBox1) {
              alert('Please enter required fields, filter option and filter value.');
              return;
            }

            setLoading(true); // Set loading to true before making the API call
            setIsSubmitted(false); // Reset the submission state

            try {

              // 1. Acquire token
              const account = accounts[0];
              const tokenResponse = await instance.acquireTokenSilent({
                  ...functionAppLoginRequest,
                  account: account
            });
            const token = tokenResponse.accessToken;
              // Make the GET API call with query parameters
              const response = await fetch(
                `${endpointUrl}?filterOption=${encodeURIComponent(
                  selectedOption
                )}&filterValue=${encodeURIComponent(textBox1.trim())}&env=${encodeURIComponent(textBox2.trim())} &userName=${userName}`,
              {
                headers: {
                Authorization: `Bearer ${token}`,
                },
              }
              
              );
            
              // Handle the response
              if (response.ok) {
                console.log('this is response from func app');
                const data = await response.text();
                setResponseHtml(data); // Store the response HTML in state
                setIsSubmitted(true); // Mark the form as submitted
              //alert(`API Response: ${JSON.stringify(data)}`);
              } else {
                alert(`Error: ${response.status} - ${response.statusText}`);
              }
            } catch (error) {
              alert(`Error: ${error.message}`);
            } finally {
                setLoading(false); // Set loading to false after the API call is complete
              }
      };
      
      
      const handleFieldChange = (setter) => (e) => {
        setter(e.target.value);
        setIsSubmitted(false); // Reset the submission state when any field changes
      };

      const goToHome = () => {
        navigate('/atsg/home');
      };
      function goBack() {
        navigate(-1); // Navigate to the previous page
    }

  return (
    <div className='menu-box shadow-xl shadow-cyan-500/30'>
      <div className='menu-title underline underline-offset-2'>
        <h2 >Get Device Details</h2>
      </div>
      <div className='menu-content'>  
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '15px' }}>
            <label htmlFor="dropdown" className='text-box-title'>Filter Option</label>
            <select
              id="dropdown"
              value={selectedOption}
              title="Seclect filter option from dropdown. Device details will be fetched based on the selected filter option and filter value."
              onChange={handleFieldChange(setSelectedOption)}
              style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '15px' }}
            >
              <option value="">-- Select --</option>
              <option value="cid">cid</option>
              <option value="SerialNumber">Serial Number</option>
            </select>
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label htmlFor="textBox1" className='text-box-title'>Filter Value</label>
            <input
              type="text"
              id="textBox1"
              title="Enter filter value based on selected filter option."
              value={textBox1}
              onChange={handleFieldChange(setTextBox1)}
              style={{ width: '95%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
            />
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label htmlFor="textBox2" className='text-box-title'>Environment</label>
            <input
              type="text"
              id="textBox2"
              title="Enter the environment (e.g., PRD, HQE, etc.)."
              value={textBox2}
              onChange={handleFieldChange(setTextBox2)}
              style={{ width: '95%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
              readOnly />
          </div>
            <div className='foot-box'>
              <button
                type="button"
                onClick={goBack} className='foot-button'
              >
                Back
              </button>
              <button
                    type="submit" className='foot-button'
                  >
                    Submit
              </button>
              <button
                    type="button"
                    onClick={goToHome} className='foot-button'
                  >
                    Home
              </button>
            </div>
        </form>
        {/* Display loading message */}
        {loading && <p style={{ textAlign: 'center', marginTop: '20px', color: '#007CA0', fontSize: '20px' }}>Loading...
          </p>}
        {/* Render the HtmlInNewWindow component when responseHtml is available */}
        {isSubmitted && responseHtml && <HtmlInNewWindow htmlContent={responseHtml} />} 

     
      </div>
    </div>
  );
}

export default GetDeviceDetails;